import { api } from "../client";
import {
  ServicedProductExtraFields,
  ServicedProductFields,
  PartialServicedProductExtraFields,
  PartialServicedProductFields,
} from "../schema/ServicedProduct";
import { Config, ConfigMutate } from "../types";

type ApiRequestConfig = Config<
  ServicedProductFields,
  ServicedProductExtraFields
>;
type ApiRequestConfigMutate = ConfigMutate<
  PartialServicedProductFields,
  PartialServicedProductExtraFields
>;

export const getServicedProducts = async (config?: ApiRequestConfig) => {
  return api.get<ServicedProductFields, ServicedProductExtraFields>(
    "serviced_products",
    config
  );
};
export const getServicedProduct = (id: number, config?: ApiRequestConfig) => {
  return api.get<ServicedProductFields, ServicedProductExtraFields>(
    `serviced_products/${id}`,
    config
  );
};

export const createServicedProduct = (config: ApiRequestConfigMutate) => {
  return api.create<
    PartialServicedProductFields,
    PartialServicedProductExtraFields
  >("serviced_products", config);
};
export const updateServicedProduct = (
  id: number,
  config?: ApiRequestConfigMutate
) => {
  return api.update<
    PartialServicedProductFields,
    PartialServicedProductExtraFields
  >(`serviced_products/${id}`, config);
};
export const deleteServicedProduct = (id: number) => {
  return api.remove<ServicedProductFields, ServicedProductExtraFields>(
    `serviced_products/${id}`
  );
};
